import Styled from 'styled-components';
import { Button } from '../buttons';

const ActionsButton = Styled(Button)`
  background: ${(props) => props.primaryColor};
  color: ${(props) => props.textColor};
  box-shadow: none;
  padding: 0px 0px;
  height: 25px !important;
  width: 25px !important;
  min-width: 25px !important;
  .icons {
    width: 17px;
  }
`;

export { ActionsButton }